module.exports = __webpack_public_path__ + "static/dapper_logo-d40f47beb6b53b1268bfc75daee93949.svg";